import { useState, useEffect } from 'react';

/**
 * Custom hook for managing active project context in DeployPage
 * Syncs with localStorage and global events
 * @returns {Object} activeProjectId, activeProjectName, setActiveProjectId, setActiveProjectName
 */
export function useActiveProject() {
    // Global active context from localStorage
    const [activeProjectId, setActiveProjectId] = useState(
        localStorage.getItem('activeProjectId') || ''
    );
    const [activeProjectName, setActiveProjectName] = useState(
        localStorage.getItem('activeProjectName') || ''
    );

    // Sync with global project change events
    useEffect(() => {
        const handleGlobalProjectChange = () => {
            const nextProjId = localStorage.getItem('activeProjectId') || '';
            const nextProjName = localStorage.getItem('activeProjectName') || '';
            setActiveProjectId(nextProjId);
            setActiveProjectName(nextProjName);
        };
        window.addEventListener('activeProjectChanged', handleGlobalProjectChange);
        return () => window.removeEventListener('activeProjectChanged', handleGlobalProjectChange);
    }, []);

    return {
        activeProjectId,
        activeProjectName,
        setActiveProjectId,
        setActiveProjectName
    };
}
